module.exports = __webpack_public_path__ + "static/media/ic_qr_code.29459f08.png";